// @flow
import environmentLoader from './utils/environmentLoader';
import getAuthorizationToken from './utils/getAuthorizationToken';
import createStore from './createStore';


export default function init() {
    const initialData = environmentLoader.load('initialData');
    if(!initialData) {
        throw new Error('InitialData is undefined');
    }

    const localeData = environmentLoader.load('localeData');

    const storeConfig = {
        api: {
            authorization: () => getAuthorizationToken().then(token => token && `Bearer ${token}`)
        }
    };

    const store = createStore(initialData, null, storeConfig);


    return {
        store,
        initialData
    };
}